// Lightweight Web Audio cues — no asset files needed.
// Synthesises short tones so the focus timer can warn / count down / signal completion.

let ctx = null;

function getContext() {
  if (typeof window === "undefined") return null;
  const Klass = window.AudioContext || window.webkitAudioContext;
  if (!Klass) return null;
  if (!ctx) ctx = new Klass();
  // Resume if suspended (browsers gate audio behind user gesture)
  if (ctx.state === "suspended") {
    ctx.resume().catch(() => {});
  }
  return ctx;
}

function beep({ frequency = 880, duration = 0.15, volume = 0.18, type = "sine", when = 0 } = {}) {
  const c = getContext();
  if (!c) return;
  const t0 = c.currentTime + when;
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = type;
  osc.frequency.value = frequency;
  gain.gain.setValueAtTime(0, t0);
  gain.gain.linearRampToValueAtTime(volume, t0 + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + duration);
  osc.connect(gain).connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + duration + 0.02);
}

// Soft tick — used at the start of the 30-second warning window
export function softBeep() {
  beep({ frequency: 660, duration: 0.12, volume: 0.14 });
}

// Sharper countdown tick (last 10 seconds)
export function countdownTick() {
  beep({ frequency: 880, duration: 0.1, volume: 0.22, type: "triangle" });
}

// "Time's up" — three rising tones
export function completeChime() {
  beep({ frequency: 587.33, duration: 0.18, volume: 0.25, type: "sine", when: 0 });
  beep({ frequency: 739.99, duration: 0.18, volume: 0.25, type: "sine", when: 0.18 });
  beep({ frequency: 987.77, duration: 0.35, volume: 0.3, type: "sine", when: 0.36 });
}

// Call this once on first user interaction to ensure context is unlocked
export function primeAudio() {
  getContext();
}
